import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { VehicleAttributeModel } from '../models/vehicleattribute.model';
import { VehicleAttributeService } from '../models/vehicleattribute.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel, Permission, PermissionType, WeGoAuthorizedLink, RoleLevel } from '../../shared/config';


@Component({
  selector: 'wego-vehicleattribute',
  template: require('../views/vehicleattribute-list.component.html'),
  providers: [VehicleAttributeService]
})
export class VehicleAttributeListComponent implements OnInit {
  urlVehicleAttributeAdd: string;
  addVehicleAttributeLink: WeGoAuthorizedLink;
  DataListModel: DataListModel;
  vehicleattributeList: VehicleAttributeModel[];
  errorMessage: string;
  isLoading: boolean;
  urlVehicleAttributeUpdate: string;
  urlDefaultPage: string;
  roleLevel = RoleLevel;
  
  private module: string;
  private breadCrumbList: string;
  constructor(private vehicleattributeService: VehicleAttributeService,
    private authService: AuthService,
    private router: Router, private translate: TranslateService) {
  }

  ngOnInit() {
    this.module = this.translate.instant('LblVehicleAttribute');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance){
      this.DataListModel.searchField = ["attributeName", "instanceName", "vehicleAttributeCategoryName", "attributeDesc"];
    }
    else{
      this.DataListModel.searchField = ["attributeName", "vehicleAttributeCategoryName", "attributeDesc"];
    }
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlVehicleAttributeAdd = this.authService.GetURL(ApplicationRouteURL.URL_VEHICLEATTRIBUTE_ADD);
    this.urlVehicleAttributeUpdate = this.authService.GetURL(ApplicationRouteURL.URL_VEHICLEATTRIBUTE_UPDATE);
    this.GetVehicleAttributeList();
    this.addVehicleAttributeLink = new WeGoAuthorizedLink(this.urlVehicleAttributeAdd, 
      Permission.PR_VEHICLE_ATTRIBUTE, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetVehicleAttributeList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetVehicleAttributeList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetVehicleAttributeList();
  };


  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetVehicleAttributeList();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.vehicleattributeService.ExportVehicleAttributeList(this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "VehicleAttributeList" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public GetVehicleAttributeList() {
    this.isLoading = true;
    this.vehicleattributeService.GetVehicleAttributeList(this.DataListModel)
      .subscribe(
      res => {
        this.vehicleattributeList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle-attribute/components/vehicleattribute-list.component.ts